import { Injectable } from '@angular/core';

import { Observable, Observer, Subscriber } from 'rxjs';

import { ContactUsDto } from './../data';

const SEND = 'contact-us.send';

@Injectable()
export class ContactUsService {
  constructor() {

  }

  public send(dto: ContactUsDto) {
    return Parse.Cloud.run(SEND, dto);
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/services/contact-us-service.ts